// test1989
(1989 && 0);
